import { Ref, watch } from 'vue';
import { AxiosError, isAxiosError } from 'axios';
import { redirectAndShowNotification } from '@infuse/ui/utils';

export const useRedirectOnNotFound = (isError: Ref<boolean>, error: Ref<Error, Error> | Ref<null, null>) => {
  watch(isError, () => {
    if (isError.value && isAxiosError(error.value) && (error.value as AxiosError).status === 404) {
      redirectAndShowNotification(3000);
    }
  });
};
